import "~/misc/common";
import { p } from "~/misc/common";
import Cookies from "js-cookie";
import { Calendar, EventSourceApi } from '@fullcalendar/core';
import { CalendarOpts } from "./calendar";

export function initCalLessons(cal: Calendar, opts: CalendarOpts) {
  p('initCalLessons');

  const calendar = cal;
  Cookies.set('lesson_back', window.location.href, { path: '/' });
  Cookies.set('lesson_locking_back', window.location.href, { path: '/' });

  // create button dynamically
  const btn = $('<button>', {
    class: 'btn btn-default margin-left-5px margin-bottom-5px toggle-calendar-lessons',
    html: '<i class="fa fa-book"></i> Napló'
  });
  $('#btnContainer').append(btn);

  let source: EventSourceApi | null = null;
  let active = !(Cookies.get('cal_no_lessons') == 'true');

  refresh();

  btn.on('click', function (e) {
    $(this).blur();
    active = !active;
    refresh();
    calendar.refetchEvents();
  });

  function refresh() {
    active ? btn.addClass('active') : btn.removeClass('active');
    Cookies.set('cal_no_lessons', (!active) + '', {
      expires: 10,
      path: '/'
    });
    if (source) {
      active ? calendar.addEventSource(source) : source.remove();
    } else if (active) {
      source = calendar.addEventSource({
        url: '/lessons.json',
        extraParams: {
          'q[teacher_user_id_or_replacer_user_id_eq]': opts.user_id
        }
      });
    }
  }

}